// extracted by mini-css-extract-plugin
export var active = "PaginationList-module--active--0fede";
export var disabled = "PaginationList-module--disabled--4c3e8";
export var leftArrow = "PaginationList-module--left-arrow--646ae";
export var numberSpan = "PaginationList-module--number-span--78d60";
export var paginationArrowContainer = "PaginationList-module--pagination-arrow-container--440ed";
export var rightArrow = "PaginationList-module--right-arrow--bfef7";